import * as actionTypes from './actionTypes';

export const setToUpdate=(number)=>({
    type:actionTypes.SET_TO_UPDATE,
    payload:number
})

